export const T = {
  en_GB: {
    gridTitle: "Portfolios — Grid",
    gridDescription:
      "Edit weights for each product across risk-score portfolios. Each column must total 100%.",
    riskNamePrefix: "Risk",
    noPlatform: "No platform",
  },
  nb_NO: {
    gridTitle: "Porteføljer — Rutenett",
    gridDescription:
      "Rediger vekt for hvert produkt på tvers av risikoscore-porteføljer. Hver kolonne må summere til 100%.",
    riskNamePrefix: "Risiko",
    noPlatform: "Ingen plattform",
  },
} as const;
